import {Nav,Home,Seats,Embed,SeatsDetail,Search,Footer,HistoricalElection,PollsDrawer,NotificationBar,PushPrompt,OnboardingHint} from './components/index';
import {Routes,Route, useLocation} from 'react-router-dom';
import { useScrollDepth } from './utils/useScrollDepth';

const App = () => {
  const { pathname } = useLocation();
  const isEmbed = pathname === "/embed";

  const routeLabel =
    isEmbed ? null
    : pathname === '/' ? 'home'
    : pathname.startsWith('/seats/') ? 'seat_detail'
    : pathname === '/seats' ? 'seats'
    : pathname === '/historical' ? 'historical'
    : pathname;
  useScrollDepth(routeLabel);
  return (
    <div className='app'>

      { !isEmbed ? <NotificationBar/> : null }
      { !isEmbed ?
      <div className="navbar">
        <Nav/>
      </div>
       : null}
      <div className="main">
      { !isEmbed ?
      <Search/> : null }
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/embed" element={<Embed/>}/>
          <Route path="/seats" element={<Seats/>}/>
          <Route path="/seats/:state" element={<SeatsDetail/>}/>
          <Route path="/seats/:state/:parliment" element={<SeatsDetail/>}/>
          <Route path="/historical" element={<HistoricalElection/>}/>
          <Route path="*" element={<p style={{textAlign:'center'}}>Error 404</p>}/>
        </Routes>
      </div>
      { !isEmbed ?
      <div className='footer'>
        <Footer/>
      </div>
      : null}
      { !isEmbed ? <PollsDrawer/> : null }
      { !isEmbed ? <PushPrompt/> : null }
      { !isEmbed ? <OnboardingHint/> : null }
    </div>
  )
}

export default App